module.exports = __webpack_public_path__ + "img/2019_2.9264cc12.jpg";